import React from "react";
import { Sidebar } from "react-admin";


const LeftSidebar = (props: any) => {

  return <Sidebar {...props} />;
};

export default LeftSidebar;
